"use client";

import { imageEffectSamples } from "@saas/shared/config/image-effect-samples";
import { ImageTransformationClient } from "@shared/components/ImageTransformationClient";

export function ImageToAnimeClient() {
	const exampleImages = {
		beforeSrc: imageEffectSamples.anime[2].before,
		afterSrc: imageEffectSamples.anime[2].after,
		altBefore: "Original Photo",
		altAfter: "Anime Style",
	};

	return (
		<ImageTransformationClient type="anime" exampleImages={exampleImages} />
	);
}
